import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, shape } from "prop-types";
import { Form, Formik } from "formik";
import { push } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import * as numberUtils from "util/number";
import { actions as loansActions } from "reducers/loans";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Button from "pages/_components/Button";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
import GridTable from "../../_components/GridTable/GridTable";
import CuotasDetail from "../_components/CuotasDetail";

const UnsecuredLoanFormConfirm = ({ isDesktop, loanSimulation }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loansActions.unsecuredLoanAplicationSetButtonLoading(false));
    }, []);

    const [openSidebarDetail, setOpenSidebarDetail] = useState(false);

    const handleDetail = () => {
        setOpenSidebarDetail(true);
    };
    const onClose = () => {
        setOpenSidebarDetail(false);
    };

    // Formik Validation Control
    const FORM_ID = "unsecuredLoanForm.confirm";

    const infoFirstRow = () => (
        <GridTable className="equivalent-total-balance">
            <GridTable.Container>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.type", "Tipo de tasa")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.rateType}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.tna", "Tasa nominal anual (TNA)")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.tna}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.tea", "Tasa efectiva anual (TEA)")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.tea}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.simulation.rate.cftea",
                            "Costo Financiero Total Efectivo Anual (CFTEA)",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.cftSIVA}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.cftea.iva", "CFTEA + IVA")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.cftCIVA}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const infoSecondRow = () => (
        <GridTable className="equivalent-total-balance">
            <GridTable.Container>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.first.installment", "Primera cuota")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.firstPureInstallment)}
                            />
                        }
                    />
                </GridTable.Data>
                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.last.installment", "Última cuota")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.lastPureInstallment)}
                            />
                        }
                    />
                </GridTable.Data>
                <div style={{ paddingBottom: "12px" }} />

                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <Button
                        image="images/figma/icon/arrow-right.svg"
                        bsStyle="link"
                        style={{ flexDirection: "row-reverse", paddingLeft: null }}
                        label="unsecured.loans.simulation.installment.detail"
                        onClick={() => handleDetail()}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const cuotasInfo = () => (
        <Drawer
            openSidebar={openSidebarDetail}
            onClose={onClose}
            isFullHeight={!isDesktop}
            enableCloseButton={!!isDesktop}>
            <CuotasDetail
                installmentList={loanSimulation.installmentList}
                isDesktop={isDesktop}
                handleClose={onClose}
                openForm={openSidebarDetail}
            />
        </Drawer>
    );

    return (
        <>
            {cuotasInfo()}
            <Formik>
                {() => (
                    <Form id={FORM_ID}>
                        <I18n component="h4" id="unsecured.loans.simulation.subtitle" />
                        <div style={{ paddingBottom: "5px" }} />
                        <Row className="form-background">
                            <div style={{ padding: "0px 24px 0px 24px" }}>
                                <I18n component="h3" id="unsecured.loans.simulation.rate.subtitle" />
                                {infoFirstRow()}
                                <div style={{ paddingBottom: "20px" }} />
                                <I18n component="h3" id="unsecured.loans.simulation.installment.subtitle" />
                                {infoSecondRow()}
                            </div>
                        </Row>
                        <div style={{ paddingBottom: "10px" }} />

                        {/* {formConfirm && ( */}
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get("unsecured.loans.simulation.disclaimer1")}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>

                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get("unsecured.loans.simulation.disclaimer2")}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>

                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get("discounts.amountToCredit.echeq.disclaimer")}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                            <div style={{ paddingBottom: "10px" }} />
                        </div>

                        <div>
                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={2}>
                                    <CustomButton
                                        text={i18n.get("", "Volver a simular")}
                                        func={() => dispatch(loansActions.unsecuresLoansApplicationPre("custom"))}
                                        className="btn-outline flex"
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6}>
                                    <CustomButton
                                        text={i18n.get("global.confirm", "Confirmar")}
                                        func={() => dispatch(push("/requestUnsecuredLoan/confirm"))}
                                        className="btn-primary flex"
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};

UnsecuredLoanFormConfirm.propTypes = {
    isDesktop: bool.isRequired,
    loanSimulation: shape({}).isRequired,
};

export default connect()(UnsecuredLoanFormConfirm);
